// src/features/counterSlice.ts
import { createSlice } from '@reduxjs/toolkit';

interface GlobalState {
  firstName: string;
  lastName: string;
  vendorCompany: string;
  licensePlate: string;
  visitorType: 'VENDOR' | 'GUEST' | 'STAFF' | '';
}

const initialState: GlobalState = {
  firstName: '',
  lastName: '',
  vendorCompany: '',
  licensePlate: '',
  visitorType: '',
};

export const visitorSlice = createSlice({
  name: 'visitor',
  initialState,
  reducers: {
    clearState: (state) => {
      state.firstName = '';
      state.lastName = '';
      state.vendorCompany = '';
      state.licensePlate = '';
      state.visitorType = '';
    },

    setVendorCompany: (state, action) => {
      state.vendorCompany = action.payload;
    },
    setFirst: (state, action) => {
      state.firstName = action.payload;
    },
    setLast: (state, action) => {
      state.lastName = action.payload;
    },
    setPlate: (state, action) => {
      state.licensePlate = action.payload;
    },
    setType: (state, action) => {
      state.visitorType = action.payload;
    },
  },
});

export const {
  clearState,
  setFirst,
  setLast,
  setPlate,
  setType,
  setVendorCompany,
} = visitorSlice.actions;

export default visitorSlice.reducer;
